import { inject, Injectable } from "@angular/core";
import { map, Observable } from "rxjs";
import { Cc7OfflineReadinessChecker } from "@rinami/cc7-ng";
import { EquipmentDao } from "../../services/dao/equipment.dao";

@Injectable({ providedIn: "root" })
export class GciinsOfflineReadinessChecker implements Cc7OfflineReadinessChecker {
  private readonly equipmentDao = inject(EquipmentDao);

  isReady(): Observable<boolean> {
    return this.equipmentDao.fetchAll().pipe(map(items => items.length > 0));
  }
}
